<template>
  <div class="ai-number-picker d-flex align-items-center flex-column">
    <div class="w-subtitle-1 font-weight-600">{{ l.t('number-picker.you-can-enter-your-business-name', 'You can enter your business name, a relevant word, or digits') }}</div>
    <div id="number-picker-container" class="w-100" @click="checkIfNumberIsClicked($event)"></div>
		<div class="w-body-1 text-center fees-text">
			{{ l.t('number-picker.some-numbers-require-a-one-time-acquisition-fee', 'Some numbers require a one-time acquisition fee.') }}
			<br>
			{{ l.t('number-picker.this-will-not-increase-your-monthly-fee', 'This will not increase your monthly fee.') }}
		</div>
  </div>
</template>

<script>
import l from '../../libs/lang';

export default {
  data() {
    return {
      l,
      url: process.env.VUE_APP_PHOENIX_URL,
      numberPickerFlow: null,
    };
  },
  async mounted() {
    try {
      const moduleUrl = 'https://express-signup-lib.cit-phone.com/latest/index.mjs';
      // eslint-disable-next-line no-new-func
      const dynamicImport = new Function('url', 'return import(url)');
      const module = await dynamicImport(moduleUrl);
      this.numberPickerFlow = module.NumberPickerFlow;

      const options = {
        partner: 'clean',
        useStyles: true,
        pdcBilling: true,
        numberPickerMode: 'ai',
        errorCallback: () => this.$emit('errorCB'),
        apiHostname: this.url,
        numberPickerMaxPrice: 99999900,
        numberPickerPageLimit: 12,
        numberPickerPaginationMode: false,
        customSearchQueryFilters: { 'filters[npa]': 'in:800,833,844,855,866,877,888' },
      };
      const instance = await this.numberPickerFlow.init(this.$session.access_token || null, options, (e) => {
        this.$emit('reserved', {
          phone_number: e.number.phone_number,
          search_id: e.number.search_id,
          do_reserve: true,
        });
      });
      await instance.render(document.getElementById('number-picker-container'));
    } catch (err) {
      console.error('Failed to load NumberPickerFlow module:', err);
      this.$emit('errorCB');
    }
  },
  methods: {
    checkIfNumberIsClicked(event) {
      const card = event.target.closest('.pdc-exsin-card');
      if (card && card.getAttribute('data-selected') === '1') {
        card.removeAttribute('data-selected');
      }
    },
  }
};
</script>

<style scoped lang="scss">
.ai-number-picker {
  padding-top: 10px;
}
.fees-text {
  color: #197F9F;
}
::v-deep {
  .pdc-exsin-number-picker {
    padding-top: 10px;

    .pdc-exsin-input {
      max-width: 500px;
      width: 100%;
      height: 51px;
      padding: 0 10px;
      outline: none;
      border-radius: 6px;
      border: 1px solid rgba(133, 146, 154, 0.65);
      color: #6E7A82;
      font-size: 13px;
      font-weight: 600;
      line-height: 16px;
      background-color: #fff;
    }
    .pdc-exsin-number-picker-numbers-list {
      background: transparent;
      box-shadow: none;

      > * {
        background: #fff;
        box-shadow: 0px 2px 8px 0px #00000040;
        border-radius: 3px;
        padding: 1rem 0;
      }
    }
    .pdc-exsin-number-picker-meta-title {
      font-weight: 700;
    }
  }
  .pdc-exsin-number-picker-wrapper {
    background-color: transparent;
    color: var(--v-text-base);
    box-shadow: unset;

    &:before,
    &:after {
      display: none !important;
    }
  }
  .pdc-exsin-step-description,
  .pdc-exsin-number-picker-help {
    display: none !important;
  }
  .pdc-exsin-form {
    max-width: unset !important;

    > .pdc-exsin-round-button {
      max-height: unset !important;
      max-width: unset !important;
      padding: 11px 20px;
    }
  }
  .pdc-exsin-price-tag {
    font-size: 11px !important;
    font-weight: 500;
    line-height: 11px;
    top: 3px !important;
    margin: 0 3px !important;
    color: #197F9F;
    background: #e1f1f5;
    border-radius: 2px;
    padding: 0 10px !important;
  }
  .pdc-exsin-number-picker-numbers-number {
    font-size: 16px;
  }
  .pdc-exsin-number-picker-numbers-number-original {
    display: none;
  }
  .pdc-exsin-number-picker-numbers-page {
    max-width: 42rem;
    gap: 1rem;
  }
  .pdc-exsin-number-picker-numbers-number-container {
    margin-right: 8px;
  }
  .pdc-exsin-icon-bg {
    fill: transparent !important;
  }
  .pdc-exsin-icon-color {
    fill: #2A9BB7 !important;
  }
  .pdc-exsin-number-picker-pagination {

    .pdc-exsin-card {
      width: 32px;
      height: 34px;
      margin-bottom: 15px;
      border-radius: 5px;
      padding: 6px 0;
      color: var(--v-text-base);
      background: #fff;
      box-shadow: 0 6px 6px 0 rgba(0, 0, 0, 0.15);
    }
    .pdc-exsin-page-button[data-status="current"] {
      color: #fff;
      background: #197F9F;
    }
  }
  .pdc-exsin-important {
    border-color: #197F9F !important;
    color: var(--v-text-base) !important;
    font-weight: 600;

    svg path {
      fill: #197F9F !important;
    }
  }
  .pdc-exsin-card[data-status="inactive"] svg path {
    fill: #8c98a0 !important;
  }
  .pdc-exsin-card[data-status="active"] svg path {
    fill: var(--v-text-base) !important;
  }
  .pdc-exsin-spinner > svg {
    height: 30px;
    width: 30px;
  }
  .pdc-exsin-number-picker-numbers-page-list-wrapper {
    border-radius: 20px;
    border: 3px solid #2A9BB7;
    border-left: 3px solid #2A9BB7 !important;
  }
  #pdc-exsin-number-picker-more-numbers {
    color: #197F9F;
  }
}
</style>
